const Portuguese = {
  "Yesterday with": "Subhas",
  'and': '123',
  'concert in LA. Was  totally fantastic! People were really excited about  this one!': '.....................................................',
  '#MotivationMonday': '#MotivationMonday',
  '#Morning': '#Morning',
  "Reference site about Lorem Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.": "38642378642984628976498726498739432333333333333333333333333333333333333333333333333333333333333333785693748597834y59783495",
  "English(en)": "Portugues(pt)",
  "Announcements": "Anúncios",
  "Featured Posts": "Postagens em destaque",
  "Action Required": "Ação requerida",
  "more liked this": "mais gostei disso",
  "Comments": "Comentários",
  "Awards": "Prêmios",
  "Upcoming Birthdays": "próximos aniversários",
  "Upcoming Work-Anniversaries": "Próximos aniversários de trabalho",
  "Popular Posts": "Postagens populares",
  "Upcoming Wedding Anniversaries": "Próximos aniversários de casamento",
  "Reference site about lorem ipsum, giving information": "Site de referência sobre lorem ipsum, com informações.",
  "Follow Up Suggestions": "Sugestões de acompanhamento",
  "Feed": "Alimentar",
  "Post": "Publicar",
  "My Feeds": "Meus feeds",
  "Feed Detail": "Detalhes do feed",
  "Featured": "Apresentou",
  "Pop. Posts": "Pop. Postagens",
  "Apply": "Aplicar",
  "Team Leaves": "Folhas de equipe",
  "My Leaves": "Minhas folhas",
  "Hello": "Olá",
  "Leave Ledger": "Sair do razão",
  "Org Leaves": "Folhas da organização",
  "Employees": "Funcionários",
  "All Teams": "Todas as equipes",
  "My Team": "Meu time",
  "Log Out": "Sair",
  "Awards": "Prêmios",
  "Quick Actions": "Ações rápidas",
  "Ticket Management": "Gerenciamento de ingressos",
  "Ticket Detail": "Detalhe do bilhete",
  "My Tickets": "Meus ingressos",
  "Add Ticket": "Adicionar ingresso",
  "Ticket Detail": "Detalhe do bilhete",
  "Leave": "Deixar",
  "Apply": "Aplicar",
  "My Leaves": "Minhas folhas",
  "Team Leaves": "Folhas de equipe",
  "Org Leaves": "Folhas da organização",
  "Leave Ledger": "Sair do razão",
  "My Leave Completed Leave": "Minha Licença Licença Concluída",
  "Gallery": "Galeria",
  "Single Gallery": "Galeria única",
  "Add Media": "Adicionar mídia",
  "Hr Assessment": "Avaliação de RH",
  "My Assessment": "Minha avaliação",
  "EmployeeAssessment": "Avaliação de funcionários",
  "Hr Assessment": "Avaliação de RH",
  "Recruitment": "Recrutamento",
  "Recruitment Dashboard": "Painel de recrutamento",
  "Recruitment Details": "Detalhes de recrutamento",
  "Create Position": "Criar posição",
  "Applicant Details": "Detalhes do candidato",
  "Add Applicant": "Adicionar candidato",
  "Applicant Search": "Pesquisa de candidatos",
  "Work From Home": "Trabalho a partir de casa",
  "Work From Home Dashboard": "Painel de trabalho em casa",
  "My Work From Home": "Meu trabalho em casa",
  "Team Work From Home": "Trabalho em equipe em casa",
  "Completed": "Concluído",
  "Pending": "Pendente",
  "More": "Mais",
  "Communication Panel": "Painel de Comunicação",
  "Create Reminders": "Crie lembretes",
  "Reminders": "Lembretes",
  "First time dashboard": "Painel pela primeira vez",
  "Audit Trails": "Trilhas de auditoria",
  "Create Owner Page": "Criar página do proprietário",
  "Account Owner Page": "Página do proprietário da conta",
  "Change Password": "Alterar a senha",
  "OTP Verification": "Verificação OTP",
  "Policy": "Política",
  "AddPolicy": "Adicionar política",
  "Policies": "Políticas",
  "Policydetail": "Detalhes da política",
  "All Teams": "Todas as equipes",
  "My Teams": "Minhas equipes",
  "New": "Novo",
  "Self Learning": "Auto-aprendizagem",
  "Instructor Training": "Treinamento de instrutor",
  "Task Management": "Gerenciamento de tarefas",
  "Task Detail": "Detalhe da tarefa",
  "Search": "Procurar",
  "Search Result": "Resultado da pesquisa",
  "What would you like to search": "O que você gostaria de pesquisar",
  "Search Employee & their post": "Pesquisar funcionário e sua postagem",
  "Profile": "Perfil",
  "Change password": "Alterar a senha",
  "Send Us Feedback": "Envie-nos comentários",
  "2022 © OrgGenie - Your Organization Portal. Powered By": "2022 © OrgGenie – Portal da sua organização. Distribuído por",
  "BizBrolly": "BizBrolly",
  "Version 16.6": "Versão 16.6",
  "Log Out": "Sair",
  "Add App": "Adicionar aplicativo",
  "App Title": "Título do aplicativo",
  "Links": "Ligações",
  "Existing App": "Aplicativo existente",
  "Apps": "Aplicativos",
  "Decline": "Declínio",
  "Save": "Salvar",


};

export default Portuguese;
